// Pack B2 Item 3: line items are added/edited via a sheet (no inline blank rows).
// Pure helpers so the add/edit/remove + totals logic is unit-testable.

export interface EditableLineItem {
  description: string;
  unitPrice: number;
}

export const emptyLineItem = (): EditableLineItem => ({ description: '', unitPrice: 0 });

/** A line item is valid (committable from the sheet) when it has a description and a non-negative amount. */
export const lineItemValid = (i: EditableLineItem): boolean =>
  i.description.trim() !== '' && i.unitPrice >= 0;

export const addLineItem = (items: EditableLineItem[], item: EditableLineItem): EditableLineItem[] => [...items, item];

export const updateLineItem = (items: EditableLineItem[], idx: number, item: EditableLineItem): EditableLineItem[] =>
  items.map((l, i) => (i === idx ? item : l));

export const removeLineItem = (items: EditableLineItem[], idx: number): EditableLineItem[] =>
  items.filter((_, i) => i !== idx);

export const subtotalOf = (items: EditableLineItem[]): number =>
  items.reduce((s, i) => s + Math.round(i.unitPrice * 100) / 100, 0);
